import React from "react";
import { selectors } from "@Src/redux/reducers";
import { useSelector } from "react-redux";
import { Button } from "@accessdev/arc-ui-react";

import "./Redeem.scss";
import { Trans } from "@lingui/react/macro";

function RedeemError({ btnText, btnCallback }) {
  const helpNumber = useSelector(selectors.getHelpPhoneNumber);
  return (
    <div className="coupon__redeem-error">
      <strong>
        <Trans>Whoops!</Trans>
      </strong>
      <p>
        <Trans>We had some trouble redeeming this deal. Please give us a call at</Trans>{" "}
        {helpNumber} <Trans>for assistance.</Trans>
      </p>
      <div>
        <Button onClick={btnCallback}>{btnText}</Button>
      </div>
    </div>
  );
}

export default RedeemError;
